import { AiFillDelete } from "react-icons/ai"; 
import React from 'react'
import { Footer } from "../components/Footer";

export const Cart = ({products, cartTotals, setCartTotals, setCartContents, cartContents}) => {

    const handleRemove = (id) => {
        const product = cartContents.find( (product) => product.id === id  );

        if (!product) {
            console.error("Product not found");
            return;
        }

        setCartTotals(Number(cartTotals) - Number(product.price));
        console.log("-------");
        console.log(product);
        setCartContents(cartContents.filter( (product) => product.id !== id ));
    }

    return (
    <>
    <div className="p-6 bg-slate-300"></div>
    <div className='flex justify-center bg-black items-center mt-100 h-48 mb-10'>
        <h1 className='text-white'>Cart</h1>
    </div>

    {cartContents.length > 0 ? (


<div className="relative overflow-x-auto">
    <table className="w-10/12 text-sm text-left rtl:text-right mx-auto text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" className="px-6 py-3">
                    ID
                </th>
                <th scope="col" className="px-6 py-3">
                    Image
                </th>
                <th scope="col" className="px-6 py-3">
                    Name
                </th>
                <th scope="col" className="px-6 py-3">
                    Price
                </th>
                <th scope="col" className="px-6 py-3">
                    Delete
                </th>
            </tr>
        </thead>
        <tbody>
          
{/* start loop */}

            {cartContents.map( (product) => (

<tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
<th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
    {product.id}
</th>
<td className="px-6 py-4">
    <img src={product.img} alt="" width="70px" />
</td>
<td className="px-6 py-4">
    {product.name}
</td>
<td className="px-6 py-4">
    €{product.price.toFixed(2)}
</td>
<td className="px-6 py-4">
    <AiFillDelete onClick={()=> handleRemove(product.id)} size="20" className="text-red-500 cursor-pointer" />
</td>
</tr>

            )  )}
           
           <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
<th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
</th>
<td className="px-6 py-4">
</td>
<td className="px-6 py-4">
    <strong>Total</strong>  
</td>
<td className="px-6 py-4">
    <strong>€{cartTotals.toFixed(2)}</strong>
</td>
</tr>       
          
{/* end loop */}

        </tbody>
    </table>
</div>



) : (
    <section className="flex justify-center m-20">
    <p>Your Cart Is Empty</p>
    </section>
) }
   
   


<Footer />
        </>
  )
}
